<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clip-rule="evenodd"
      d="M3.874 2.193A2.014 2.014 0 0 0 1 4.021v16.852a2.014 2.014 0 0 0 2.874 1.828l17.957-8.426a2.014 2.014 0 0 0 0-3.656L3.874 2.193Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="m4.49 2.476 14.301 13.226M4.715 22.31 18.723 9.163"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
